class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
window.addEventListener("load", function () {

    //
    $(".item-tinhtu").each(function(index) {
        var $btnNhan = $(this).find(".btn-nhan");
        
        if ($(this).hasClass("received")) {
          $btnNhan.text($btnNhan.data("received"));
      } else {
          $btnNhan.text($btnNhan.data("default")) ;
      }
        
    });
    $(".btn-nhanluot").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(".list-nhanluot").css("display", "flex");
    });

    $(".list-nhanluot").on("click", function(e) {
        e.stopPropagation();
    });

    if (window.innerWidth <= 768 && window.matchMedia("(orientation: portrait)").matches) {
        $(document).on("click", function() {
            $(".list-nhanluot").css("display", "none");
        });
    }

    $(".list-nhanluot .nv").each(function(index) {
        var $btnNhan = $(this).find(".btn-nhan");
        
        if ($(this).hasClass("received")) {
          $btnNhan.text($btnNhan.data("received"));
      } else {
          $btnNhan.text($btnNhan.data("default")) ;
      }
        
    });


    const dndPromotion = window.libraryMainsite.promotion;
    const core = new Core();
    
    // Cache jQuery selector
    const $items = $(".gr_effect--item");
    const totalItems = $items.length;
    
    // Animation timing constants
    const LOOP_DELAY = 80;
    const FINAL_DELAY = 210;
    const CLEANUP_DELAY = 300;
    //const BUFFER_TIME = 200;
    
    // Function to calculate animation duration based on prizeIndex
    function calculateAnimationTime(prizeIndex) {
        const targetIndex = prizeIndex - 1;
        const loopTime = 2 * totalItems * LOOP_DELAY;
        const finalLoopTime = (targetIndex + 1) * FINAL_DELAY;
        return loopTime + finalLoopTime + CLEANUP_DELAY;
    }
    
    async function animateItems(startIndex, endIndex, delay, removePrevious = true) {
        for (let i = startIndex; i <= endIndex; i++) {
            if (removePrevious && i > 0) {
                $items.eq(i - 1).removeClass("active");
            }
            $items.eq(i).addClass("active");
            await core.wait(delay);
        }
    }
    
    async function animationRandom(prizeIndex) {
        const targetIndex = prizeIndex - 1;
        
        $items.removeClass("active");
        
        for (let loop = 0; loop < 2; loop++) {
            if (loop > 0) {
                $items.eq(totalItems - 1).removeClass("active");
            }
            await animateItems(0, totalItems - 1, LOOP_DELAY);
        }
        
        $items.eq(totalItems - 1).removeClass("active");
        await animateItems(0, targetIndex, FINAL_DELAY);
        
        setTimeout(() => {
            $items.removeClass("active");
        }, CLEANUP_DELAY);
    }

    // Handle mouse wheel scroll on .list-tinhtu for horizontal scrolling
    $(".list-tinhtu").on("wheel", function(e) {
        e.preventDefault();
        var deltaX = e.originalEvent.deltaX;
        var deltaY = e.originalEvent.deltaY;
        var scrollAmount = deltaX !== 0 ? deltaX : deltaY;
        this.scrollLeft += scrollAmount;
    });

    // Handle touch/swipe for mobile devices
    var touchStartX = 0;
    var touchEndX = 0;
    var isScrolling = false;

    $(".list-tinhtu").on("touchstart", function(e) {
        touchStartX = e.changedTouches[0].screenX;
        isScrolling = true;
    });

    $(".list-tinhtu").on("touchmove", function(e) {
        if (!isScrolling) return;
        
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > 5) { // Threshold to avoid accidental touches
            this.scrollLeft += diff * 0.5; // Adjust sensitivity with 0.5 multiplier
            touchStartX = touchEndX;
        }
    });

    $(".list-tinhtu").on("touchend", function() {
        isScrolling = false;
    });

    // Create config object that can be updated dynamically
    const promotionConfig = {
        timeWait: 3900 // Default value, will be updated dynamically
    };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: promotionConfig,
        animResult: function (listPrize) {
            const prizeIndex = listPrize[0].indexImg;
            
            // Calculate and update timeWait based on animation duration
            promotionConfig.timeWait = calculateAnimationTime(prizeIndex); 
            animationRandom(prizeIndex);
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") {
                prodTemplate.fnPromotion();
            }
        },
    });
});
